import React from 'react'
import IconButton from 'material-ui/IconButton'

export const MyPointer = () => {
    return (
        <IconButton className="size-40">
            <i className="zmdi zmdi-colorize"/>
        </IconButton>
    )
};

export default MyPointer


// WEBPACK FOOTER //
// ./app/routes/pickers/routes/Color/customPointer/MyPointer.js